import { render } from "./ModulesMain.vue?vue&type=template&id=2aaf54b3"
import script from "./ModulesMain.vue?vue&type=script&lang=js"
export * from "./ModulesMain.vue?vue&type=script&lang=js"

import "./ModulesMain.vue?vue&type=style&index=0&id=2aaf54b3&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__